'use strict';

/**
 * Removes trailing forward slashes if they exist.
 *
 * If the string doesn't end with a slash, we simply return it.
 */
var unTrailingSlashIt = function unTrailingSlashIt(str) {
  if (str.endsWith('/') || str.endsWith('\\')) {
    return unTrailingSlashIt(str.slice(0, -1));
  }

  return str;
};

/**
 * Appends a trailing slash.
 *
 * Will remove a trailing forward slash if it exists already, before adding a
 * trailing forward slash. This prevents double slashing a string or path.
 */
var trailingSlashIt = function trailingSlashIt(str) {
  return unTrailingSlashIt(str) + '/';
};

module.exports = trailingSlashIt;
module.exports.trailingSlashIt = trailingSlashIt;
module.exports.unTrailingSlashIt = unTrailingSlashIt;


//////////////////
// WEBPACK FOOTER
// ../~/trailing-slash-it/build/index.js
// module id = 142
// module chunks = 2